import React from "react";

import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { useRenderDateValue } from "hooks";
import { CurrencyType, DateRangeValue, ReportFilters } from "store/types";

interface Props {
  dateRange: DateRangeValue;
  currency: CurrencyType;
  filters: ReportFilters;
}

export const ReportQueries: React.FC<Props> = ({ dateRange, currency, filters }) => {
  const previewDate = useRenderDateValue();
  const filtersCount = Object.keys(filters || {}).length;
  return (
    <Stack sx={{ flexDirection: "row", alignItems: "center", bgcolor: "#F6F8FC", p: "4px", gap: "10px" }}>
      <Typography sx={{ fontWeight: 700, fontSize: "12px", lineHeight: "16px" }}>Parameter Set:</Typography>
      <Stack sx={{ flexDirection: "row", alignItems: "center", gap: "4px" }}>
        <Typography sx={{ fontWeight: 500, fontSize: "12px", lineHeight: "16px" }}>Time Frame:</Typography>
        <Typography sx={{ fontWeight: 400, fontSize: "12px", lineHeight: "16px" }}>{previewDate(dateRange)}</Typography>
      </Stack>
      <Stack sx={{ flexDirection: "row", alignItems: "center", gap: "4px" }}>
        <Typography sx={{ fontWeight: 500, fontSize: "12px", lineHeight: "16px" }}>Currency:</Typography>
        <Typography sx={{ fontWeight: 400, fontSize: "12px", lineHeight: "16px" }}>{currency}</Typography>
      </Stack>
      {filtersCount > 0 && (
        <Typography sx={{ fontWeight: 400, fontSize: "12px", lineHeight: "16px" }}>+ ({filtersCount})</Typography>
      )}
    </Stack>
  );
};
